import { Card, CardContent, CardHeader, Divider, makeStyles, Button, Grid } from '@material-ui/core'
import React, { useState } from 'react'
import Filter from './components/Filter'
import BanksTable from './components/BanksTable'
import AddBank from './components/AddBank'
import Popup from '../../components/Popup'

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: 100,
        padding: theme.spacing(1)
    },
    content: {
        marginTop: theme.spacing(3)
    },
}))

const Banks = () => {
    const classes = useStyles()
    const [addBankPopup, setAddBankPopup] = useState(false)
    return (
        <Card className={classes.root}>
            <CardHeader title="بانک ها و شعب" action={
                <Button variant="contained" color="primary" onClick={() => setAddBankPopup(true)}>
                    اضافه کردن بانک
                    </Button>
            } />
            <Popup
                title="اضافه کردن بانک"
                openPopup={addBankPopup}
                setOpenPopup={setAddBankPopup}
            >
                <AddBank setPopup={setAddBankPopup} />
            </Popup>
            <Divider />
            <CardContent>
                <Filter />
                <Grid className={classes.content}>
                    <BanksTable />
                </Grid>
            </CardContent>
        </Card>
    )
}

export default Banks
